<template>
  <div>
    <hr style="margin-top:20px;" />
    <div style="width: 100%;">
      <h5 style="float: left;">Office {{ index + 1 }}</h5>
    </div>
    <div>
      <textInput
        title="Address line 1"
        :keyChain="['offices', index, 'address_line_1']"
        placeholder="Address line 1"
      ></textInput>
      <textInput
        title="Address line 2"
        :keyChain="['offices', index, 'address_line_2']"
        placeholder="Address line 2"
      ></textInput>
      <textInput
        title="Address line 3"
        :keyChain="['offices', index, 'address_line_3']"
        placeholder="Address line 3"
      ></textInput>
      <textInput
        title="City"
        :keyChain="['offices', index, 'city']"
        placeholder="City"
      ></textInput>
      <textInput
        title="Post code"
        :keyChain="['offices', index, 'zip_code']"
        placeholder="Post code"
      ></textInput>
      <textInput
        title="Email"
        :keyChain="['offices', index, 'email']"
        placeholder="Email address"
      ></textInput>
      <textInput
        title="Phone number"
        :keyChain="['offices', index, 'phone_number']"
        placeholder="Phone number"
      ></textInput>
      <div class="dropdown">
        <label class="options" for="dropbtn">Country</label>
        <button
          name="dropbtn"
          class="options dropbtn"
          style="padding-top: 2px;padding-bottom: 2px;"
        >
          {{ selectedCountry(index) }}
        </button>
        <div class="dropdown-content">
          <div class="modal-content" style="max-height: 400px;">
            <div class="form-group input-group">
              <span
                style="background: white; border-width: 0px 0px 1px 0px; border-radius: 0px; font-size: 10px;"
                class="input-group-addon"
                ><i class="fa fa-search icon"></i
              ></span>
              <input
                type="text"
                style="width: 100%; margin: 0px; border-radius: 0px; border-width: 0px 0px 1px 0px;"
                placeholder="search"
                v-model="countrySearchQuery"
                class="form-group input-group"
              />
            </div>
            <div
              v-for="propertyObj in searchFilteredPropertyArray"
              v-if="propertyObj.array.length > 0"
            >
              <h4 style="margin-right: 10px; float: right; font-size: 15px;">
                {{ propertyObj.letter }}
              </h4>
              <input
                v-for="item in propertyObj.array"
                type="button"
                class="btn-default"
                style="margin: 0px; border-radius:0px; width: 100%; border-width: 0px 0px 1px 0px; display: block; text-align: left;"
                :value="item.name"
                v-bind:class="{
                  selected: isSelectedCountry(item)
                }"
                v-on:click="methodToRunOnSelect(item)"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="officeList" style="float: right;">
        <button
          class="btn-default btn-delete"
          style="margin-top: 0px; margin-left: 0px;"
          type="button"
          @click="removeOffice(index)"
        >
          Remove office
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import textInput from "../elements/textInput.vue";
import utils from "../components/utils.js";

export default {
  name: "provider-page",
  components: {
    textInput: textInput
  },
  data() {
    return {
      propertyArray: [],
      countrySearchQuery: ""
    };
  },
  props: ["index"],
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain",
      countries: "countries"
    }),
    officeList: function() {
      return this.getProperty(["offices"]);
    },
    countriesWithIndex: function() {
      return this.countries.map(country => {
        return {
          name: country.name,
          index: this.index,
          country: country
        };
      });
    },
    searchFilteredPropertyArray: function() {
      if (this.countrySearchQuery != "") {
        var filteredPropertyArray = this.propertyArray.map(collection => {
          return {
            letter: collection.letter,
            array: collection.array.filter(item => {
              return (
                item.name
                  .toLowerCase()
                  .indexOf(this.countrySearchQuery.toLowerCase()) > -1
              );
            })
          };
        });
        return filteredPropertyArray;
      } else {
        return this.propertyArray;
      }
    }
  },
  methods: {
    ...mapMutations({
      deleteProviderProperty: "deleteEditedProviderPropertyByKeyChain",
      setEditedProviderByKeyChain: "setEditedProviderByKeyChain"
    }),
    createNewOffice: function() {
      this.$store.commit("createNewOffice");
    },
    methodToRunOnSelect: function(payl) {
      this.setEditedProviderByKeyChain({
        data: payl.country.id,
        keyChain: ["offices", payl.index, "country_id"]
      });
      this.setEditedProviderByKeyChain({
        data: payl.country,
        keyChain: ["offices", payl.index, "country"]
      });
    },
    removeOffice: function(index) {
      this.deleteProviderProperty(["offices", index]);
    },
    isSelectedCountry: function(country) {
      var officeCountryId = this.getProperty([
        "offices",
        this.index,
        "country_id"
      ]);
      if (officeCountryId) {
        return officeCountryId == country.country.id;
      } else {
        return false;
      }
    },
    selectedCountry: function(index) {
      var name = this.getProperty(["offices", index, "country", "name"]);
      if (name) {
        return name;
      } else {
        return "Choose country";
      }
    }
  },
  created() {
    const alphabet = utils.alphabet();
    for (var letter of alphabet) {
      this.propertyArray.push({
        letter: letter,
        array: utils.arrangeListByLetter(this.countriesWithIndex, letter)
      });
    }
  }
};
</script>

<style scoped>
.selected {
  color: lightgrey;
}

.dropbtn {
  cursor: pointer;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  width: 600px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  left: 110px;
  top: -110px;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: lightgrey;
}

.modal-content {
  position: absolute;
  z-index: 1;
  padding-top: 200px;
  left: 4px;
  top: -5px;
  background-color: #fefefe;
  margin: auto;
  padding: 0px;
  border: 1px solid #888;
  max-height: 60vh;
  overflow: scroll;
}

button {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 6px;
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/elements/officesInputForm.vue